import React from "react";
import SeoForm from "./components/SeoForm";

function AddSubcategorySeo() {
  return <SeoForm entityType="subcategory" />;
}

export default AddSubcategorySeo;
